import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import IconTune from '@/shared/icons/NewDesign/IconTune'
import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconLocked from '@/shared/icons/NewDesign/IconLocked'
import IconAlertCircle from '@/shared/icons/NewDesign/IconAlertCircle'
import IconUser from '@/shared/icons/NewDesign/IconUser'
import IconCarbonScript from '@/shared/icons/IconCarbonScript'
import { canManageBetaFeatures } from '@/containers/DevToolsNew/BetaFeatures/canManageBetaFeatures'
import { isSalesScriptAvailable } from '@/containers/SubscriptionFormPageNew/Components/SalesScript/isSalesScriptAvailable'

export const devToolsSections = [
  { key: 'contacts', labelKey: 'common.routes.contacts', Icon: IconShieldPerson },
  { key: 'pod-updater', labelKey: 'common.routes.pod_updater', Icon: IconBolt },
  {
    key: 'commands',
    labelKey: 'common.routes.commands',
    Icon: IconTune,
    isVisible: ({ extraRoutes }) => Boolean(extraRoutes?.devTools?.commands),
  },
  { key: 'cache', labelKey: 'common.routes.cache', Icon: IconLocked },
  { key: 'communication', labelKey: 'common.routes.communication', Icon: IconAlertCircle },
  {
    key: 'sales-script',
    labelKey: 'common.routes.sales_script',
    Icon: IconCarbonScript,
    isVisible: isSalesScriptAvailable,
  },
  {
    key: 'testers',
    labelKey: 'common.routes.testers',
    Icon: IconUser,
    isVisible: canManageBetaFeatures,
  },
]
